import React from 'react';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import MembershipSection from '../components/MembershipSection';

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <MembershipSection />
    </>
  );
};

export default HomePage;
